import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import ErrorMessage from '@/components/form/ErrorMessage'

export interface FormTextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  error?: string
  containerClassName?: string
}

const FormTextArea = forwardRef<HTMLTextAreaElement, FormTextAreaProps>(
  ({ error, className, containerClassName, ...props }, ref) => {
    return (
      <div className={twMerge('flex flex-col', containerClassName)}>
        <textarea
          {...props}
          ref={ref}
          className={twMerge(
            'flex w-full rounded-md border border-primary-300 dark:border-primary-700 focus:border-primary-600 dark:focus:border-primary-500',
            'bg-transparent px-3 py-2 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-primary-900 dark:file:text-primary-100',
            'text-primary-900 dark:text-primary-100 placeholder:text-primary-400 dark:placeholder:text-primary-500',
            'focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50',
            className ?? '',
          )}
        />
        {error && <ErrorMessage className="mt-[2px]">{error}</ErrorMessage>}
      </div>
    )
  },
)

FormTextArea.displayName = 'FormTextArea'

export default FormTextArea
